import { GetDashboardUnit } from '~/domain/usecases/dashboard/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import { UnexpectedError, NotFound, Forbidden } from '~/domain/errors';
import '~/infra/global/variables';

export class RemoteGetDashboardUnit implements GetDashboardUnit {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetDashboardUnit.Model>;

  constructor(url: string, httClient: HttpClient<GetDashboardUnit.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  get = async (
    params: GetDashboardUnit.Params,
  ): Promise<GetDashboardUnit.Model> => {
    const initialDate = new Date('1950-10-10');
    const today = new Date();

    const queryParams = {
      begin: params.begin ?? initialDate.toISOString(),
      end: params.end ?? today.toISOString(),
    };

    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.org}/units/${params.unit}`,
      method: 'get',
      params: queryParams,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new UnexpectedError();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      case HttpStatusCode.notFound:
        throw new NotFound();
      default:
        throw new UnexpectedError();
    }
  };
}
